<template>
  <div
    ref="legendContainer"
    :class="[this.legendOpen ? '' : 'collapse', 'legend']"
  >
    <OpacitySlider
      v-show="this.legendOpen && !this.$store.getters.getDialogOpen"
    />
    <v-icon @click="toggleLegend()" class="toggle close" color="black"
      >mdi-arrow-collapse</v-icon
    >
    <v-icon @click="toggleLegend()" class="toggle open" color="black"
      >mdi-menu</v-icon
    >
    <span class="legend-content">
      <!-- <h4>{{layer.title}}</h4> -->
      <span
        v-bind:class="{ hidden: tractsOn || votingPrecinctsOn }"
        v-html="layer.title"
      ></span>
      <!-- <span v-if="layer.description">{{layer.description}}</span> -->
      <span
        v-bind:class="{ hidden: tractsOn || votingPrecinctsOn }"
        v-if="layer.description"
        v-html="layer.description"
      ></span>
      <div
        v-bind:class="{ hidden: tractsOn || votingPrecinctsOn }"
        v-for="(l, i) in legendValues"
        :key="i"
      >
        <span
          :style="{ backgroundColor: l.color, border: `0px solid ${l.color}` }"
        ></span>
        {{ l.label }}
      </div>

      <v-divider class="my-2"></v-divider>

<!-- VAP map legend -->
      <div class="layer-toggle-container">
        <LayerToggleButton
          ref="tractVAPToggle"
          :buttonLabel="''"
          :layerid="['tract-vap']"
          :isChoroLayer="true"
          v-show="!this.$store.getters.getDialogOpen"
          hide-details="auto"
        />
        Overlay: VAP Plurality (2020)

        <p class="ma-0" v-show="tractsVAPOn">
          Each color shows the largest group based on<br />2020 Voting Age Population
          (VAP).<br />Color intensity shows each group's share
        </p>

        <img
          class="tract-legend"
          src="vap_tract_legend_compact.png"
          v-show="tractsOn && tractsVAPOn"
          width="280"
        />
      </div>
<!-- CVAP map legend -->
      <div class="layer-toggle-container">
        <LayerToggleButton
          ref="tractToggle"
          :buttonLabel="''"
          :layerid="['tract-cvap']"
          :isChoroLayer="true"
          v-show="!this.$store.getters.getDialogOpen"
          hide-details="auto"
        />
        Overlay: CVAP Plurality (2019)

        <p class="ma-0" v-show="tractsOn && !tractsVAPOn">
          Each color shows the largest group based on<br />2015-19 Citizen
          Voting Age Pop. (CVAP).<br />Color intensity shows each group's share
        </p>
        <!-- cvap tract legend img width was 300 -->
        <img
          class="tract-legend"
          src="cvap_tract_legend_compact.png"
          v-show="tractsOn && !tractsVAPOn"
          width="280"
        />
      </div>

      <div class="layer-toggle-container precincts">
        <LayerToggleButton
          ref="precinctToggle"
          :buttonLabel="''"
          :layerid="['voting-precincts']"
          :isChoroLayer="true"
          v-show="!this.$store.getters.getDialogOpen"
        />

        <!-- <span v-if="layer.description">{{layer.description}}</span> -->
        <span
          class="plaintitle"
          v-if="this.precinctLayer.titleplaintext"
          v-html="this.precinctLayer.titleplaintext"
        ></span>
        <span
          v-bind:class="{ hidden: !votingPrecinctsOn, description: true }"
          v-if="this.precinctLayer.description"
          v-html="this.precinctLayer.description"
        ></span>
        <div
          v-bind:class="{ hidden: !votingPrecinctsOn }"
          v-for="(l, i) in precinctLegendValues"
          :key="i"
        >
          <span
            :style="{
              backgroundColor: l.color,
              border: `0px solid ${l.color}`,
            }"
          ></span>
          {{ l.label }}
        </div>
      </div>

      <v-divider class="my-2"></v-divider>
      <div class="layer-toggle-container">
        <LayerToggleButton
          :buttonLabel="''"
          :layerid="['county-outline', 'county-outline-labels']"
          :isChoroLayer="false"
          :defaultOn="true"
          v-show="!this.$store.getters.getDialogOpen"
        />
        <img
          style="vertical-align: middle"
          src="county_legend_transbackground.png"
        />
        Counties
        <span
          class="zoom-message"
          v-show="
            !this.$store.getters.getDialogOpen &&
            this.$store.getters.getMapZoom < 7
          "
          >(Zoom in to view)</span
        >
      </div>
    </span>
  </div>
</template>
<script>
import {
  Config,
  Enums,
  LegislativeChoropleth,
  VotingChoropleth,
} from "../../data/Config/Config";
import OpacitySlider from "../../components/DataDisplay/OpacitySlider";
import LayerToggleButton from "../Menus/LayerToggleButton";
import {EventBus} from "../../data/EventBus";

export default {
  name: "MapLegend",
  components: {
    OpacitySlider,
    LayerToggleButton,
  },
  data: function () {
    return {
      Enums: Enums,
      Config: Config,
      LegislativeChoropleth: LegislativeChoropleth,
      VotingChoropleth: VotingChoropleth,
      legendOpen: true,
      isMounted: false
    };
  },
  computed: {
    mapColumn: function () {
      return this.$store.getters.getMapColumn;
    },
    layer: function () {
      return LegislativeChoropleth.config[this.mapColumn];
    },
    legendValues: function () {
      return this.layer.getLegendValues(this.layer.scale);
    },
    precinctLayer: function () {
      return VotingChoropleth.config["votingPrecincts"];
    },
    precinctLegendValues: function () {
      return this.precinctLayer.getLegendValues(this.precinctLayer.scale);
    },
    tractsLoading: function () {
      return this.$store.getters.getTractsLoading;
    },
    tractsOn: function () {
      if (!this.isMounted) {
        return false;
      }

      return this.$store.getters.getgeoTypeVisible === "tracts"; //this.$refs.tractToggle.checkbox;
    },
    tractsVAPOn: function () {
      if (!this.isMounted) {
        return false;
      }

       const qObj = this.$store.getters.getVapLayerOn ? 'true' : -1;
     
      EventBus.updateQueryObj(['tractVAPLayer', qObj])
      return this.$store.getters.getVapLayerOn;
    },
    votingPrecinctsOn: function () {
      if (!this.isMounted) {
        return false;
      }
      // console.log(this.$store.getters.getgeoTypeVisible === "voting-precincts")
      return this.$store.getters.getgeoTypeVisible === "voting-precincts"; //this.$refs.tractToggle.checkbox;
    },
  },
  mounted: function () {
    this.legendOpen =
      !this.$store.getters.isMobile && !this.$store.getters.isEmbedded;
    this.$nextTick(() => (this.isMounted = true));
  },
  methods: {
    toggleLegend() {
      this.legendOpen = !this.legendOpen;
    },
  },
};
</script>
<style scoped>
.legend {
  background-color: #fff;
  border-radius: 3px;
  bottom: 50px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 10px 22px;
  position: absolute;
  right: 60px;
  z-index: 1;
  /* max-width: 332px; */
  max-width: 305px;
}

.legend.collapse {
  padding: 8px;
}

.tract-legend {
  display: block;
  /* padding-bottom: 30px; */
  margin-left: -10px;
}

.hidden,
.legend.collapse .legend-content,
.legend.collapse .toggle.close,
.legend .toggle.open {
  display: none !important;
}

.toggle.close {
  position: absolute;
  bottom: 5px;
  right: 5px;
  transform: rotate(90deg);
}

.legend.collapse .toggle.open {
  display: block !important;
}

.legend h4 {
  margin: 0 0 10px;
}

.legend div span {
  border-radius: 15%;
  display: inline-block;
  height: 15px;
  margin-right: 5px;
  width: 15px;
  margin-bottom: -4px;
  /* border: 1px solid darkgrey; */
  border: 1px solid rgb(253, 253, 253);
  opacity: 0.9;
}

.legend .plaintitle {
  width: fit-content;
}

.legend .description {
  width: 80%;
}

.legend .zoom-message {
  width: auto;
}

.tract-circle-loading {
  margin-bottom: 4px;
  margin-left: 10px;
}

.layer-toggle-container {
  margin: -20px 0;
}

.layer-toggle-container.precincts {
  margin-bottom: 0;
}
/* .legend div span.county-outline {
    border-radius: 15%;
    display: inline-block;
    height: 15px;
    margin-right: 5px;
    width: 15px;
    margin-bottom: -4px;
    border: 3px solid darkgrey;
        opacity: .9;
} */
</style>